import { lazy } from "react"
import { ComponentsType } from "@Types/CommonsTypes"

const ManualTransition = lazy(() => import("@Components/Core/ProductTransition/ManualTransition"))

export const sodimac: ComponentsType = {
  ProductTransition: ManualTransition,
}
